<template>
        <div>
            <v-flex
                    row wrap align-top justify-center>
                <List :elements="plugins"
                      :titleHeader="header"
                      :addNewTitle="addNewPluginTitle"
                      :createCallback="navigate"
                      :clickCallback="navigate"
                      :deleteCallback="openDeletePluginDialog"></List>
            </v-flex>

            <v-dialog
                    v-model="deletePluginDialog"
                    max-width="650"
            >
                <v-card>
                    <v-card-title class="headline">Deleting {{ selectedPlugin.namespace}} /
                        {{ selectedPlugin.name }}</v-card-title>
                    <v-card-text>
                        Are you sure?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat="flat"
                                @click="closeDeletePluginDialog()"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                                color="red"
                                flat="flat"
                                @click="deletePlugin()"
                        >
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
</template>

<script>
    import RouterService from "@/helpers/RouterService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";
    import TextService from "@/helpers/TextService";
    import List from "@/components/Lists/List";

    export default {
        name: "PluginsList",
        components: {List},
        props: ["type"],
        data() {
            return {
                header: '',
                prefix: '',
                suffix: '',
                addNewPluginTitle: "Add new",
                plugins: [],
                selectedPlugin: {},
                deletePluginDialog: false,
            }
        },
        created() {
            if (this.type === "plugins") {
                this.header = "Plugins";
                this.prefix = "Plugin";
                this.suffix = "plugin";
            } else if (this.type === "functions") {
                this.header = "Functions";
                this.prefix = "Function";
                this.suffix = "function";
            }
            this.getPluginList();
        },
        methods: {
            navigate(plugin) {
                let path = {
                    name: "PluginDetailsTraining",
                    params: {
                        pluginType: this.type,
                        pluginId: plugin.id || TextService.generateRandomString(16),
                        pluginName: plugin.name,
                        pluginNamespace: plugin.namespace,
                    },
                };
                RouterService.goTo(path);
            },
            openDeletePluginDialog(plugin) {
                this.selectedPlugin = plugin;
                this.deletePluginDialog = true;
            },
            closeDeletePluginDialog() {
                this.selectedPlugin = {};
                this.deletePluginDialog = false;
            },
            getPluginList() {
                this.plugins = [];
                // Compute plugins
                let requestUrl = {
                    url: UrlsService.plugins,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestBody = {
                    interactionData: {
                        pluginsInteractionRequest: {
                            pluginOperation: "getPluginsByScenarioId",
                            plugin: {
                                info: {
                                    type: this.type,
                                }
                            }
                        },
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestBody,
                    },
                };
                let messages = {
                    title: "Retrieving plugins",
                    loading: "Waiting for plugins...",
                    error: "Retrieving failed",
                    success: "Plugins list got.",
                };
                let options = {
                    loadingType: "none",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        let plugins = response.response.pluginObject.plugins;
                        for (let i = 0; i < plugins.length; i++) {
                            let plugin = {
                                id: plugins[i].info.id,
                                name: plugins[i].info.name,
                                namespace: plugins[i].info.namespace,
                                description: plugins[i].info.description,
                                nameToShow: plugins[i].info.namespace + ":" + plugins[i].info.name,
                            };
                            this.plugins.push(plugin);
                            if (i !== plugins.length - 1) {
                                this.plugins.push({divider: true, inset: false,});
                            }
                        }
                    })
                    .catch(responseError => {

                    });
            },
            deletePlugin() {
                // Compute plugins
                let requestUrl = {
                    url: UrlsService.plugins,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestBody = {
                    interactionData: {
                        pluginsInteractionRequest: {
                            pluginOperation: "deletePlugin",
                            plugin: {
                                info: {
                                    type: this.type,
                                    id: this.selectedPlugin.id,
                                    name: this.selectedPlugin.name,
                                    namespace: this.selectedPlugin.namespace,
                                }
                            }
                        },
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestBody,
                    },
                };
                let messages = {
                    title: "Deleting plugin",
                    loading: "Waiting for plugin deletion...",
                    error: "Deletion failed",
                    success: "Plugin deleted correctly.",
                };
                let options = {
                    loadingType: "none",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.selectedPlugin = {};
                        this.deletePluginDialog = false;
                        this.getPluginList();
                    })
                    .catch(responseError => {
                        this.selectedPlugin = {};
                        this.deletePluginDialog = false;
                    });
            }
        }
    }
</script>

<style scoped>

</style>